<template>
    <div id="colour-match-tool-notice" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <span class="title">Important Information</span>

        <p class="description" style="text-align: left">
            Technical Colour Match is a tool tailored for close matching two <b>similarly</b> shot images and works optimally
            under such conditions. If the difference between the source and target images is significant, this could
            lead to artifacts in the resulting image as the tool is very "eager". If you want to match two significantly
            different shots, it's best to use the "AI Colour Extract" or "AI Colour Match" tools.
        </p>

        <div class="buttons-continer --single-item">
            <button @click="onConfirm" type="button" class="modal-btn --primary">I understand</button>
        </div>

        <div class="option-container">
            <div class="switch switch-container">
                <input type="checkbox" v-model="doNotShow" name="do-not-show" />
                <span class="slider round"></span>
            </div>
            <span class="option-title">Do not show this message again</span>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    data() {
        return {
            doNotShow: false,
        };
    },
    methods: {
        onConfirm() {
            if (this.doNotShow) {
                Cookies.set("ColourMatchToolNotice", true);
            }

            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.option-container {
    margin-top: 34px;

    > .switch {
        margin-left: initial;
    }
}
</style>
